import { Link } from "../router/router";
import { t } from "../i18n";

/** Rodapé das páginas web (gestão, atleta e entrada). `helpTo` só aparece com a pessoa autenticada. */
export function AppFooter({ helpTo, className = "" }: { helpTo?: string; className?: string }) {
  const year = new Date().getFullYear();
  return (
    <footer className={`app-footer ${className}`.trim()}>
      <div className="app-footer-inner">
        <p className="app-footer-brand">
          <strong>EAPace</strong>
          <span>{t("Treino inteligente para ir mais longe.")}</span>
        </p>
        <nav className="app-footer-links" aria-label={t("Rodapé")}>
          {helpTo && <Link to={helpTo}>{t("Ajuda")}</Link>}
          <a href="mailto:suporte@eapace.com">{t("Fale com o suporte")}</a>
        </nav>
        <p className="app-footer-copy">© {year} EAPace. {t("Todos os direitos reservados.")}</p>
      </div>
    </footer>
  );
}
